import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Comment16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_315)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M0.249969 1.49997C0.249969 0.809614 0.809613 0.249969 1.49997 0.249969H14.5C15.1903 0.249969 15.75 0.809614 15.75 1.49997V11.5C15.75 12.1903 15.1903 12.75 14.5 12.75H7.81063L5.38388 15.1767C4.59643 15.9642 3.25 15.4065 3.25 14.2929V12.75L1.49995 12.75C0.809602 12.75 0.249969 12.1903 0.249969 11.5V1.49997ZM1.74997 1.74997V11.25L4.75 11.25V13.6893L7.18931 11.25H14.25V1.74997H1.74997Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_315'>
        <rect width='16' height='16' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

Comment16.displayName = 'Comment16';
export default Comment16;
